import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
const FloatingButton = styled(Button)(() => ({
  padding: "0.25rem 1rem 0.25rem 1rem",
  cursor: "pointer",
  borderRadius: "0.5rem",
  fontSize: "0.875rem",
  height: "3.25rem",
  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.3), 0px 8px 12px 6px rgba(0, 0, 0, 0.15)"
}));
export {
  FloatingButton
};
